import { render, staticRenderFns } from "./TwTradingInformation.vue?vue&type=template&id=f8615d10&scoped=true&"
import script from "./TwTradingInformation.vue?vue&type=script&lang=js&"
export * from "./TwTradingInformation.vue?vue&type=script&lang=js&"
import style0 from "./TwTradingInformation.vue?vue&type=style&index=0&id=f8615d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8615d10",
  null
  
)

export default component.exports